var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuernsey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0234C24.8366 32.0234 32 24.86 32 16.0234C32 7.18688 24.8366 0.0234375 16 0.0234375C7.16344 0.0234375 0 7.18688 0 16.0234C0 24.86 7.16344 32.0234 16 32.0234Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9365H18.0871H18.087V0.158875C17.4038 0.0699375 16.7073 0.0234375 16 0.0234375C15.2927 0.0234375 14.5962 0.0699375 13.9131 0.158875V13.9365H0.135438C0.0465 14.6196 0 15.3161 0 16.0234C0 16.7308 0.0465 17.4272 0.135438 18.1104H13.9129H13.913V31.888C14.5962 31.9769 15.2927 32.0234 16 32.0234C16.7073 32.0234 17.4038 31.977 18.0869 31.888V18.1106V18.1104H31.8646C31.9535 17.4272 32 16.7308 32 16.0234C32 15.3161 31.9535 14.6196 31.8646 13.9365V13.9365Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5218 16.719L21.5652 17.4147V14.6321L20.5218 15.3278H16.6956V11.5017L17.3913 10.4582H14.6087L15.3044 11.5017V15.3278H11.4783L10.4348 14.6321V17.4147L11.4783 16.719H15.3044V20.5452L14.6087 21.5886H17.3913L16.6956 20.5452V16.719H20.5218Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0234375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuernsey);
export default __webpack_public_path__ + "static/media/guernsey.2cf736d0.svg";
export { ForwardRef as ReactComponent };